import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Card = ({ title, count, link, icon, subtitle }) => (
  <Link
    to={link}
    className="group bg-white shadow-sm border border-gray-100 rounded-lg w-full transform transition-all duration-300 hover:shadow-lg hover:scale-[1.02] relative overflow-hidden block cursor-pointer"
  >
    {/* Gradient overlay on hover */}
    <div className="absolute inset-0 bg-gradient-to-r from-indigo-50/0 to-indigo-50/0 group-hover:from-indigo-50/50 group-hover:to-transparent transition-all duration-300"></div>
    
    <div className="p-6 relative">
      <div className="flex items-center mb-4">
        <div className="p-2 bg-indigo-50 rounded-lg transform transition-transform group-hover:scale-110 group-hover:rotate-3">
          <div className="transform transition-transform group-hover:rotate-[-3deg]">
            {icon}
          </div>
        </div>
        <h3 className="text-lg text-gray-800 ml-3 tracking-tight group-hover:text-indigo-600 transition-colors">
          {title}
        </h3>
      </div>
      <div className="flex flex-col">
        <div className="flex items-baseline">
          <p className="text-3xl text-gray-900 tracking-tight transition-transform group-hover:translate-x-1">
            {count}
          </p>
          {subtitle && (
            <p className="text-sm text-gray-500 ml-2 transition-opacity group-hover:opacity-75">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
    <div className="w-full bg-gray-50 hover:bg-gray-100 flex justify-between items-center p-4 rounded-b-lg transition-all duration-200 group-hover:bg-indigo-50/50 border-t border-gray-100">
      <p className="text-indigo-600 text-sm font-medium transition-transform group-hover:translate-x-1">
        View details
      </p>
      <ArrowRight className="text-indigo-600 w-4 h-4 transform transition-transform group-hover:translate-x-1" />
    </div>

    {/* Shine effect on hover */}
    <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100">
      <div className="absolute inset-0 transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
    </div>
  </Link>
);

export default Card;
